import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiSearchDonViTrong(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_TRONG.SEARCH,
    method: "GET",
    params: payload,
  });
}

export function callApiGetMultiDonViTrong(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_TRONG.GET_MULTY,
    method: "POST",
    data: payload,
  });
}

export function callApiGetDonViTrongIgnore(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_TRONG.SEARCH_IGNORE,
    method: "POST",
    data: payload,
  });
}

export function callApiSearchDonViTrongDonViNgoai(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_TRONG.SEARCH_DON_VI_TRONG_DON_VI_NGOAI,
    method: "GET",
    params: payload,
  });
}

export function callApiGetListPXLYKien(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_TRONG.PHAN_XU_LY_Y_KIEN,
    method: "GET",
    params: payload,
  });
}
